export default {
  login_admin: "/account/login_user/",
  register_user: "/account/register_user/",
};
